import React from "react"
import { Box, Button, Center, Container, Heading } from "@chakra-ui/react"

import { SectionProps, withSection } from "@app/hoc/Section"
import { useArticles } from "@hooks/useArticles"
import FeaturedArticlesGrid from "./FeaturedArticlesGrid"
import FeaturedArticlesCarousel from "./FeaturedArticlesCarousel"
import { useRoutes } from "@hooks/useRoutes"
import Link from "@components/Link"

export interface FeaturedArticlesProps extends SectionProps {
  title?: string
  articles: GatsbyTypes.SanityArticle[]
  category: GatsbyTypes.SanityArticleCategory
  link?: GatsbyTypes.SanityInternal
  customLink?: string
  customLinkText?: string
  theme: "Light" | "Dark"
  display: "grid" | "carousel"
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  hideBadges?: boolean
}

const FeaturedArticles = ({
  title,
  category,
  articles: featured,
  link,
  theme,
  display,
  carouselSettings,
  innerRef,
  handleTrackingClick,
  customLink,
  customLinkText,
  hideBadges = false,
}: FeaturedArticlesProps) => {
  const { urlResolver } = useRoutes()
  const { getArticles, normaliseArticles } = useArticles()

  const articles = category?.handle?.current ? getArticles(category?.handle?.current) : featured?.length ? featured : []
  const resolvedLink = urlResolver(link)
  const items = articles.length && normaliseArticles(articles)

  return items?.length ? (
    <Box
      id={`featured-articles`}
      pt={3}
      pb={3}
      bg={theme === "Dark" ? "brand.beige.dark" : "white"}
      overflow="hidden"
      ref={innerRef}
      as="section"
    >
      {title && (
        <Heading as="h2" size="h2" mb={2.5} textAlign="center" px={2}>
          {title}
        </Heading>
      )}
      <Container>
        {display === "carousel" ? (
          <FeaturedArticlesCarousel items={items} carouselSettings={carouselSettings} handleTrackingClick={handleTrackingClick} hideBadges={hideBadges} />
        ) : (
          <FeaturedArticlesGrid items={items} handleTrackingClick={handleTrackingClick} />
        )}
      </Container>
      {link ? (
        <Center mt={4}>
          <Button variant="blue" as={Link} to={resolvedLink.url}>
            {resolvedLink.title}
          </Button>
        </Center>
      ) : customLink ? (
        <Center mt={4}>
          <Button variant="blue" as={Link} to={customLink}>
            {customLinkText}
          </Button>
        </Center>
      ) : null}
    </Box>
  ) : (
    <></>
  )
}

export default React.memo(withSection(FeaturedArticles))
